import { render, staticRenderFns } from "./ShowEventDotBase.vue?vue&type=template&id=88cff50e&scoped=true&"
import script from "./ShowEventDotBase.vue?vue&type=script&lang=ts&"
export * from "./ShowEventDotBase.vue?vue&type=script&lang=ts&"
import style0 from "./ShowEventDotBase.vue?vue&type=style&index=0&id=88cff50e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cff50e",
  null
  
)

export default component.exports